import { submitValidation, StreamHandler, ValidationRequest } from 'services/apiService';
import {
  FindingStreamHandlers,
  streamFindings,
} from 'services/findingsService';

export interface ValidationRouteHandlers {
  onLegacyStream?: StreamHandler;
  findings?: FindingStreamHandlers;
}

export function isCanonicalElementContent(content: string): boolean {
  try {
    const parsed = JSON.parse(content);
    return (
      parsed !== null &&
      typeof parsed === 'object' &&
      typeof parsed.id === 'string' &&
      typeof parsed.type === 'string' &&
      parsed.properties !== null &&
      typeof parsed.properties === 'object' &&
      !Array.isArray(parsed.properties)
    );
  } catch {
    return false;
  }
}

export async function submitElementValidation(
  request: ValidationRequest,
  token: string | undefined,
  address: string | null | undefined,
  signal: AbortSignal | undefined,
  handlers: ValidationRouteHandlers,
): Promise<'canonical' | 'legacy'> {
  if (isCanonicalElementContent(request.Content)) {
    await streamFindings(
      request,
      token,
      address,
      handlers.findings ?? {},
      signal,
    );
    return 'canonical';
  }

  await submitValidation(
    request,
    token,
    address,
    signal,
    handlers.onLegacyStream,
  );
  return 'legacy';
}
